// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mapSelectionMarker{transform:translate(-50%,calc(-100% - 12px))}.mapSelectionMarker:after{position:absolute;content:\"\";width:0;height:0;bottom:-18px;left:50%;border:7px solid transparent;border-top:12px solid #000;transform:translate(-50%)}.mapSelectionMarker.selected:after{border-top-color:#fdca4e}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
